import Backbone from 'backbone'
import template from './on-off-toggle.hbs'
import _ from 'lodash'

/*
 * On Off Toggle:
 *
 * toggle to represent true/false checkbox
 *
 * Usage:
 * this.toggle = new OnOffToggle({
		name : 'thresholdOverride', // required!
		checked : false,
		label: 'Option label text.' // Optional
		disabled: false,            // Optional
		isMini: true								// Optional
	}).render()
 *
 * this.toggle.on('change', function(checked) { })
 */

var OnOffToggle = Backbone.View.extend({

	// Typically, the top level class name matches the file, but there is an
	// option to include a label within the component. Therefore, it wouldn't make
	//  sense to have the the label and actual toggle within the main toggle class.
	//  So we'll, give it a `container` class name instead.
	className: 'on-off-toggle-container',

	events: {
		'click' : 'toggle'
	},

	initialize: function (options) {
		this.options = options || {}
	},

	render: function () {
		this.$el.html(template(this.options))
		this.$el.data('view', this)
		return this
	},

	/**
	 * Gets or sets the value of the toggle. If the provided value is not nil,
	 * the value of the toggle will be set according to the truthiness of the
	 * value. If the value is nil, returns true if the toggle is on, and
	 * false if it's off
	 */
	val: function (value) {
		var input = this.$('[name=' + this.options.name +']')
		if (_.isNil(value)) {
			var val = input.prop('checked')
			return val
		} else {
			input.prop('checked', !!value)
		}
	},

	/**
	 * Triggers a change event
	 */
	change: function(e) {
		this.trigger('change', this.val(), e)
	},

	toggle: function (e) {
		// necessary to avoid triggering an event twice.  The event is triggered
		// once on the input element and once on the .switch.  I tried ignoring
		// one of those or only listening to one of those, but the toggle
		// wouldn't work with any combination of things I tried other than this
		e && e.preventDefault()

		// If the toggler is disabled, don't allow toggling
		if (this.$('input').prop('disabled')) {
			this.trigger('disabled')
			return
		}

		var val = this.val()
		var input = this.$('[name=' + this.options.name +']')
		input
			.prop('checked', !val)
			// trigger DOM change event so FormView can do its thing
			.trigger('change', e)

		this.trigger('change', this.val(), e)
	}
})

export default OnOffToggle

OnOffToggle.__filename__ = 'components/on-off-toggle.js'
